<div class="gridControls">
  <div id="databaseGridControls">
    <span class="grid-control">
      <va-period-filter
        [periodData]="defaultPeriodObj"
        [filterWidthVariation]="3"
        [periodMinMax]="periodMinMax"
        (onApply)="periodSettingsChange($event)"
      ></va-period-filter>
    </span>
    <div class="grid-control">
      <!-- <app-data-revisions-dropdown
        [singleSelect]="true"
        [showReset]="true"
        [dataView]="dataView"
        (saveDataView)="updateDataView($event)"
      ></app-data-revisions-dropdown> -->
      <app-pharma-database-data-revisions-dropdown
        [singleSelect]="true"
        [showReset]="true"
        [dataView]="dataView"
        (saveDataView)="updateDataView($event)"
      ></app-pharma-database-data-revisions-dropdown>
    </div>
    <div class="grid-control">
      <div nz-col class="filter-holder revenue-type" style="width: 123px">
        <label class="filter-label">Revenue Type/Risk</label>
        <nz-select
          [(ngModel)]="revenueType"
          nzBorderless
          style="width: 100%; border-bottom: 1px solid #c5ccd6"
          (ngModelChange)="onRevenueTypeChange()"
          [nzDropdownClassName]="'select-dropdown-style'"
          [nzBackdrop]="true"
        >
          <ng-container *ngFor="let type of revenueTypeOptions">
            <nz-option
              [nzValue]="type.value"
              [nzLabel]="type.label"
            ></nz-option>
          </ng-container>
        </nz-select>
      </div>
    </div>
    <div class="grid-control currency-filter">
      <va-currency-select
        size="small"
        selectWidth="78"
        labelPlacement="top"
        [bottomBorderView]="true"
        [(selectedCurrency)]="selectedCurrency"
        [disabled]="currencyDisabled"
        [apiEP]="apiEP"
        apiUrl="/api/get_available_currencies"
        (onChange)="onCurrencyChange($event)"
      >
      </va-currency-select>
    </div>
    <div class="grid-control nib-filter">
      <div
        nz-col
        class="filter-holder revenue-type"
        style="max-height: 44px; margin-bottom: 4px"
      >
        <label class="filter-label">Filters</label>
        <div class="show-consolidated">
          <label
            nz-checkbox
            [(ngModel)]="showNIB"
            [nzDisabled]="showNIBControl"
            (ngModelChange)="showNIBChange()"
            style="min-height: 40px"
          >
            Include Consolidated-Only Revenues
            <span *ngIf="!showNIBControl"> ({{ consolidatedCount }}) </span>
          </label>
          <span
            class="info-icon-class"
            [ngClass]="{
              'disable-info-icon': showNIBControl
            }"
          >
            <span
              nz-popover
              nzPopoverPlacement="right"
              [nzPopoverContent]="popoverContentTemplate"
              nzPopoverTrigger="hover"
              class="info-icon"
              [nzPopoverOverlayStyle]="{ width: '350px' }"
            >
              <va-icon size="small" name="info-circle"></va-icon>
            </span>
          </span>
        </div>
      </div>
    </div>
    <span class="grid-control breakdown-switch">
      <label
        nz-checkbox
        [(ngModel)]="indicationBreakout"
        (ngModelChange)="indicationBreakoutChange()"
        [nzDisabled]="indicationBreakoutContol"
      >
        Expand all indications
      </label>
    </span>
  </div>

  <div class="export">
    <span class="grid-control" style="padding-right: 4px">
      <app-database-column-picker
        [defaultSelectedCols]="columnList"
        (onChange)="onColumnPickerChange($event)"
      ></app-database-column-picker>
    </span>
    <app-export-to-excel-dropdown
      [(isPopoverVisible)]="isExportPopoverVisible"
      [optionList]="excelToExportDropdownOptions"
      [isExportInProgress]="isExportInProgress"
      (onListItemClick)="handleETEListItemClick($event)"
    ></app-export-to-excel-dropdown>
  </div>

  <ng-template #popoverContentTemplate>
    <div>
      <span style="font-weight: 700">
        Include Consolidated-Only Revenues:
      </span>
      <br />
      <span>
        By default, the grid includes only drugs for which analyst forecasts
        provide revenue by indication. Enable this option to include drugs for
        which revenue by indication is unavailable to show combined revenue
        forecasts for the drug in the grid and in the sum line
      </span>
      <!-- <br /><br />
      <span style="text-wrap: wrap; word-break: break-all"
        >Turning off the toggle will show the total drug revenue in the grid and
        in the sum line.</span
      > -->
    </div>
  </ng-template>
</div>
